//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../no/NXObject.js";
let d=[[],[],[]];
SPLM.Fields.SpatialMap = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.SpatialMap";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Fields.SpatialMap.TypeEnum = Object.freeze({
    "None" : "None", "Global" : "Global", "Cartesian" : "Cartesian", "Cylindrical" : "Cylindrical", "Spherical" : "Spherical", "ParametricSpace" : "ParametricSpace", "ParametricPlane" : "ParametricPlane", "ParametricLine" : "ParametricLine", "ImportedParametricLine" : "ImportedParametricLine"});

SPLM.Fields.SpatialMap.SubtypeEnum = Object.freeze({
    "None" : "None", "Surface" : "Surface", "FitSurface" : "FitSurface"});

SPLM.Fields.SpatialMap.SubtypeMappingEnum = Object.freeze({
    "Faces" : "Faces", "IsoSections" : "IsoSections", "IsoLines" : "IsoLines"});

SPLM.Fields.SpatialMap.BoundingBoxMapEnum = Object.freeze({
    "OppositeCorner" : "OppositeCorner", "Objects" : "Objects"});

SPLM.Fields.SpatialMap.ParametricPlaneMapEnum = Object.freeze({
    "IsoSections" : "IsoSections", "IsoLines" : "IsoLines", "ImportedIsoLines" : "ImportedIsoLines"});

export default SPLM;